<script>
// component
import SmartMap from './components/SmartMap'
import ProjectListInput from './components/ProjectListInput'
import ProjectListSelect from './components/ProjectListSelect'
import ProjectList from './components'

// api
import {
  getCommunityListByCompanyId,
  searchProjectList
} from '~/api/community.api'

export default {
  head() {
    const url = process.env.ONLINE_URL + this.$route.path
    const title = `${this.company.shortName}装修工地直播`
    const desc = `${this.company.shortName}在建工地，${this.company.shortName}装修工地直播详情，施工流程、工艺水平、装修服务全面呈现，不用出门就能看到${this.company.shortName}真实装修工地，让您的装修选择更放心！`
    const location = `province=${this.companyProvince};city=${this.companyCity}`
    return {
      title,
      meta: [
        {
          name: 'keywords',
          content: `${this.company.shortName}装修工地,${this.company.shortName}装修流程`
        },
        {
          name: 'description',
          content: desc
        },
        {
          name: 'og:url',
          content: url
        },
        {
          name: 'og:title',
          content: title
        },
        {
          name: 'og:description',
          content: desc
        },
        {
          name: 'location',
          content: location
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: url
        }
      ]
    }
  },
  components: {
    SmartMap,
    ProjectListInput,
    ProjectListSelect,
    ProjectList
  },
  data() {
    return {
      userAgent: false,
      initMarkerId: null,
      screenWidth: 0,
      screenHeight: 0,
      showMask: false,
      isExpand: false,
      showLeftBar: true,
      filter: {
        id: '',
        region: '',
        style: '',
        room: '',
        sort: '1'
      },
      target: '',
      multySelectValue: [],
      origin: [],
      communityDetail: [],
      searchInput: [{ value: 'This is a test' }],
      show: [],
      markers: [],
      mapContext: {}
    }
  },
  watch: {
    target: {
      handler(newVal) {
        this.mapContext.moveTo({ markerId: this.target })
      }
    }
  },
  asyncData(context) {
    const {
      company,
      province: companyProvince,
      city: companyCity
    } = context.store.state.company
    const companyLocation = {
      latitude: company.latitude,
      longitude: company.longitude
    }
    console.log('companyLocation', companyLocation)
    const companyId = company.companyId
    return { company, companyId, companyCity, companyProvince, companyLocation }
  },
  mounted() {
    const that = this
    that.screenWidth = document.body.clientWidth
    that.screenHeight = document.body.clientHeight - 60

    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
        that.screenHeight = document.body.clientHeight - 60
      })()
    }
  },
  async created() {
    this.userAgent = this.$route.query.userAgent || false
    await this.initCommunity(this.companyId)
    if (this.$route.query.communityId) {
      this.initMarkerId = Number(this.$route.query.communityId)
    }
  },
  methods: {
    moveTarget,
    initfilter,
    onMarkerClick,
    onMapResize,
    onGetMapContext,
    initCommunity,
    onClickLeftBar,
    onClickClose,
    visibleChange
  }
}
function onMapResize(obj) {
  this.isExpand = obj.mode === 'expand'
}
function visibleChange(bool) {
  this.showMask = bool
  this.isExpand = false

  if (bool) {
    this.isExpand = false
  }
}
function onClickClose() {
  this.showMask = false
}
function onClickLeftBar() {
  this.showLeftBar = !this.showLeftBar
}
function moveTarget(targetId, targetRegion, targetDistrict) {
  this.showLeftBar = true
  this.filter.id = targetId
  this.filter.region = targetRegion
  this.multySelectValue = [targetDistrict, targetRegion]
  this.target = targetId
}
function initfilter(filter, communityId) {
  ;({
    style: this.filter.style,
    sort: this.filter.sort,
    room: this.filter.room,
    region: this.filter.region
  } = filter)
  this.showLeftBar = true
  this.target = communityId
}
async function initCommunity(companyId) {
  const res = await getCommunityListByCompanyId({
    companyId
  })
  this.origin = res.data.data
  this.searchInput = this.origin.map((item) => {
    return {
      value: item.community_name,
      address: item.address,
      district: item.district,
      id: item.community_id
    }
  })
  this.markers = res.data.data.map((item) => {
    return {
      markerId: item.community_id,
      latitude: item.latitude,
      longitude: item.longitude,
      title: item.community_name,
      subTitle: item.projectcount
    }
  })
  const detail = await searchProjectList({})
  this.communityDetail = detail
}
function onMarkerClick(marker) {
  this.showLeftBar = true
  this.isExpand = false
  const communityId = marker.markerId
  const result = []
  this.searchInput.map((item) => {
    if (String(item.id) === String(communityId)) {
      // to-do elicxh 将所有区域不知道的区域更新为 其他区域
      item.district = item.district ? item.district : '其它地区'
      result.push(item.district)
      result.push(item.value)
    }
  })
  this.multySelectValue = result
}
function onGetMapContext(map) {
  this.mapContext = map
}
</script>
<template>
  <div class="projectlist_container">
    <div class="projectlist_search_filter">
      <div class="projectlist_serach_area">
        <ProjectListSelect
          :multy-value="multySelectValue"
          @visibleChange="visibleChange"
          @init-filter="initfilter"
        />
      </div>
      <div class="projectlist_serach_input">
        <ProjectListInput
          :community-list="searchInput"
          @move-to-target="moveTarget"
        />
      </div>
    </div>
    <div class="list_and_map">
      <div
        v-show="showMask"
        @click="onClickClose"
        class="list_and_map_mask"
      ></div>
      <div
        :class="
          screenWidth < 901 || showLeftBar
            ? 'projectlist_list'
            : 'projectlist_list_none'
        "
      >
        <ProjectList
          v-show="screenWidth < 901 || showLeftBar"
          :filter="filter"
        />
        <div class="projectlist_bar">
          <div class="all_border"></div>
          <div
            @click="onClickLeftBar"
            class="projectlist_arrow shrink"
            onclick=""
          >
            <svg
              :class="
                showLeftBar
                  ? 'projectlist_arrow_img_close arrow_svg'
                  : 'projectlist_arrow_img_open arrow_svg'
              "
              width="9px"
              height="24px"
              viewBox="0 0 9 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="svg_fill"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  transform="translate(-492.000000, -585.000000)"
                  fill-rule="nonzero"
                >
                  <g id="编组-12" transform="translate(479.000000, 114.000000)">
                    <g id="编组-13" transform="translate(0.000000, 451.000000)">
                      <g id="收起" transform="translate(13.000000, 20.000000)">
                        <path
                          id="形状"
                          d="M-5.74103487,15.7328112 C-6.16364114,15.9871016 -6.69296978,15.9836965 -7.11226952,15.72399 C-7.53156926,15.4642836 -7.77041785,14.9918942 -7.73101075,14.5002574 C-7.69160365,14.0086206 -7.38055939,13.5803078 -6.92524539,13.3907059 L3.6010704,8.12754802 C3.97350141,7.93987882 4.41284991,7.93987882 4.78528092,8.12754802 L15.3115967,13.3907059 C15.9021135,13.7460314 16.1184019,14.4968092 15.8074311,15.1118404 C15.4964602,15.7268716 14.7636061,15.9977459 14.1273862,15.7328112 L4.19317566,10.7722849 L-5.74103487,15.7328112 Z"
                          transform="translate(4.106977, 11.953986) rotate(-90.000000) translate(-4.106977, -11.953986) "
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div class="projectlist_map">
        <!-- <div id="pc_owner_map" /> -->
        <SmartMap
          v-if="screenWidth < 901"
          :draggable="true"
          :init-mode="isExpand ? 'expand' : 'collapse'"
          :collapse-height="200"
          :expand-height="screenHeight - 40"
          :markers="markers"
          :per-location="companyLocation"
          :enable-resize="true"
          :init-marker-id="initMarkerId"
          :user-agent="userAgent"
          @marker-click="onMarkerClick"
          @map-resized="onMapResize"
          enable-scale
          @get-map-context="onGetMapContext"
          map-dom-id="pc_owner_map"
        />
        <SmartMap
          v-else
          :draggable="true"
          :collapse-height="screenHeight"
          :markers="markers"
          :per-location="companyLocation"
          :enable-resize="false"
          :init-marker-id="initMarkerId"
          @marker-click="onMarkerClick"
          @get-map-context="onGetMapContext"
          enable-scale
          map-dom-id="pc_owner_map"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@media screen and (min-width: 901px) {
  :deep(.el-input__inner) {
    height: 54px;
    border-radius: 0px;
  }
  .projectlist_serach_input {
    :deep(.el-input__inner) {
      border-radius: 0px;
    }
  }
}
@media screen and (max-width: 901px) {
  :deep(.el-input__inner) {
    height: 40px;
    border-radius: 0px;
  }
}
</style>
<style lang="scss" scoped>
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
@keyframes close {
  from {
    flex: 480px 0 0;
  }
  to {
    flex: 0px 0 0;
  }
}
@keyframes open {
  from {
    flex: 0px 0 0;
  }
  to {
    flex: 480px 0 0;
  }
}

.projectlist_container {
  .app_header {
    margin-bottom: 0;
    .app_header_logo {
      width: 36px;
      height: 36px;
      > img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .app_header_project_short_name {
      font-size: 20px;
      font-weight: 500;
      color: rgba(42, 42, 42, 1);
      line-height: 20px;
      padding-left: 10px;
    }
  }
}

.selected {
  color: #37c6d8 !important;
}
.is-focus {
  > input {
    border-color: #37c6d8 !important;
  }
}
.in-active-path,
.is-active {
  span,
  i {
    color: #37c6d8 !important;
  }
}
//pc only
@media screen and (min-width: 901px) {
  .projectlist_container {
    .projectlist_search_filter {
      height: 54px;
      display: flex;
      .projectlist_serach_area {
        flex: 480px 0 0;
      }

      .projectlist_serach_input {
        width: 100%;
        height: 100%;
      }
    }
    .list_and_map {
      display: flex;
      height: calc(100vh - 54px);
      .projectlist_list {
        // overflow: hidden;
        position: relative;
        flex: 360px 0 0;
        z-index: 99;
      }

      .projectlist_list_none {
        // overflow: hidden;
        animation: myfirst 1s;
        position: relative;
        z-index: 99;
      }
      #svg_fill {
        fill: #9b9b9b;
      }
      @media (any-hover: hover) {
        .projectlist_bar:hover {
          .all_border {
            border: 1px solid #00bfd1;
            position: absolute;
            display: flex;
            top: 0;
            bottom: 0;
            right: -2px;
          }
          .shrink {
            background-color: #00bfd1;
            border: 1px solid #00bfd1;
            #svg_fill {
              fill: #ffffff;
            }
          }
        }
      }
      .projectlist_arrow {
        cursor: pointer;
        border: 1px solid rgba(239, 241, 242, 1);
        position: absolute;
        display: flex;
        background-color: white;
        height: 64px;
        width: 36px;
        top: 50%;
        right: -36px;
        border-radius: 0px 5px 5px 0px;
        align-items: center;
        justify-content: center;
        text-align: center;
        transform: translate(0%, -50%);
      }
      .projectlist_arrow_img_open {
        transform: rotateY(180deg);
      }
      .projectlist_arrow_img_close {
        transform: rotateY(0deg);
      }
      .projectlist_map {
        flex-grow: 1;
        #pc_owner_map {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
//mobile only
@media screen and (max-width: 901px) {
  .projectlist_arrow {
    display: none;
  }
  .projectlist_map {
    // flex-grow: 3;
    #pc_owner_map {
      width: 100%;
      height: 100%;
    }
  }

  .projectlist_container {
    .app_header {
      border-bottom: 1px solid rgba(239, 241, 242, 1);
    }
    .list_and_map {
      height: calc(100vh - 100px);
      display: flex;
      position: relative;
      flex-direction: column-reverse;
      .list_and_map_mask {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.6);
        width: 100%;
        height: 100%;
        z-index: 1000;
      }
    }
    .projectlist_list {
      max-width: 100%;
      flex: 1;
      height: 0px;
    }
    .projectlist_search_filter {
      // position: sticky;
      // top: 0;
      display: flex;
      z-index: 10;
      flex-direction: column;
      .projectlist_serach_area {
        order: 2;
        .el-input__inner {
          padding-left: 5px !important;
          padding-right: 25px !important;
        }
      }
      .projectlist_serach_area_all_screen {
        order: 2;
        .el-input__inner {
          padding-left: 5px !important;
          padding-right: 25px !important;
        }
      }
      .projectlist_serach_input {
        order: 1;
        height: 60px;
        line-height: 60px;
        background: white;
      }
    }
  }
}
</style>
